/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import { Loader } from '@zeeve-platform/loader-component';
import { Link } from 'react-router-dom';
import { Breadcrumb } from '@zeeve-platform/breadcrumb-component';
import SubscribedEndpoint from './endpointCard';
import RightButtons from './ButtonsComponent';
import Urls from '../../utils/urls';
import { prefixPath, getItemCodeMap } from '../../utils/helpers';
import apiBackendInstance from '../../utils/axios';

export type subscriptionDataInterface = {
  subscriptionId: string;
  planDetails: {
      code: string;
      name: string;
      characteristics: {
          apiUnits: number;
          endpoints: number;
          hitsPerSecond: number;
          archive: boolean;
          debug: boolean;
          trace: boolean;
      };
  };
  consumption: {
      apiUnits: number;
      endpoints: number;
  };
  createdAt: Date;
};

const EndpointBody = ({ theme }: { theme: string }) => {
  const [endpointConfigurationData, setEndpointConfigurationData] = useState<subscriptionDataInterface[]>([]);
  const [showLoader, setShowLoader] = useState(false);
  const paths = [{ name: 'Home', path: prefixPath('/dashboard') }, { name: 'RPC Endpoints ', path: prefixPath('/endpoints') }];

  const loaderUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);
  useEffect(() => {
    let isActive = true;
    setShowLoader(true);
    apiBackendInstance.get(Urls.getEndpointConfiguration(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (isActive && response && response.data && response.data.data) {
        setEndpointConfigurationData(response.data.data);
      }
      setShowLoader(false);
    }).catch(() => {
      setEndpointConfigurationData([]);
      setShowLoader(false);
    });

    return () => { isActive = false; };
  }, []);
  const imgSubPath = window.location.origin;
  const addIconImg = imgSubPath + prefixPath(`/img/${theme}/add-icon.png`);
  const itemCodeMap: { [key: string]: string } = getItemCodeMap();
  console.log(itemCodeMap);
  const getItemCode = (val:string) => itemCodeMap[val];
  const from = localStorage.getItem('from') ?? '';
  const path_one = localStorage.getItem('workspaceName') ?? '';
  const path_url = localStorage.getItem('workspace_url') ?? '';
  const workspacePath = [{ name: 'Workspaces', path: prefixPath('/workspace') }, { name: path_one, path: prefixPath(`/workspace/${path_url}`) }];
  const rpcEndpoint = [{ name: 'Dashboard', path: prefixPath('/dashboard') }, { name: 'RPC Endpoint', path: prefixPath('/endpoints') }];

  return (
    <>
      <section className="px-5 col-12 workspace">
        <div className="cardBlack">
          <div className="row mt-4 pt-1">
            <div className="col-lg-6 pt-2 mt-2 col-xl-6 col-sm-12 col-xs-12">
              <p className="fs-7">
                <h6>
                  <span className="mt-2 fw-bold">Configure Your Endpoint</span>
                </h6>
              </p>
              {from === 'workspace' ? (
                <Breadcrumb prefixLink={workspacePath} activeLink="Subscriptions" />
              ) : (
                  <p> </p>
              )}

              {from === 'rpcEndpoint' ? (
                <Breadcrumb prefixLink={rpcEndpoint} activeLink="Subscriptions" />
              ) : (
                <p> </p>
              )}
            </div>
            <RightButtons theme={theme} />
            <div className="mt-2 row" style={{ minHeight: '100px' }}>
              {
                endpointConfigurationData.map((o, idx) => (
                  <SubscribedEndpoint
                    key={`${idx.toString()}subcard`}
                    totalEndpoint={o.planDetails.characteristics.endpoints}
                    subscriptionId={o.subscriptionId}
                    configItemCode={getItemCode(o.planDetails.code)}
                    planName={o.planDetails.name}
                    availableEndpoint={o.planDetails.characteristics.endpoints - o.consumption.endpoints}
                    consumedCount={o.consumption.apiUnits}
                    totalUnit={o.planDetails.characteristics.apiUnits}
                    cardType="public"
                  />
                ))
              }
              <div className="col-lg-4 col-xl-3 col-md-5 col-sm-12 mt-5 cursor mg-auto">
                <div className="workSpaceCard cursor " style={{ height: '100%' }}>
                  <Link to={prefixPath('/endpoint/buy')} style={{ textDecoration: 'none' }}>
                    <div className="card-body text-center add-workspace">
                      <div className="mt-4 mx-auto">
                        <img className="mt-2 mb-3" src={addIconImg} alt="" />
                      </div>
                      <h6 className="mt-2 activeTextColor">Buy Subscription</h6>
                      <p>
                        Purchase RPC endpoint for your blockchain protocol
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
              {showLoader && <Loader imagePath={loaderUrl} />}
            </div>
          </div>
        </div>

      </section>

    </>
  );
};

export default EndpointBody;
